import { ReactNode, createContext, useContext, useState } from "react";
import { AppType } from "../../App";

export type ScreenVariations = 'handyCookGuide' | 'convertRecipe' | 'ingredientsSwap' | 'tipsAndClasses' | 'guideAndTools' | 'recipeIdeas' | 'cookingTechniques' | 'kitchenHacks' | 'mealPrep' | 'nutritionTips' | 'recipeLiterature';
const ScreenContext = createContext<any>({});

export function ScreenProvider(props: {
    children: ReactNode,
    appType: AppType
}){

    const [currentScreen, setCurrentScreen] = useState<ScreenVariations|null>(null);

    const contextData = {
        currentScreen,
        setCurrentScreen,
        appType: props.appType
    }

    return(
        <ScreenContext.Provider value={contextData}>
            {props.children}
        </ScreenContext.Provider>
    )

}

export function useScreenContext(){
    const context = useContext(ScreenContext)
    return context;
}

export default ScreenProvider;